import { Button } from "@mui/material";
import CommonModal from "components/shared/common-modal/CommonModal";
import { t } from "i18next";

const ConfirmationModal = ({
  showConfirmationPopup,
  showConfirmationMsg,
  cancelClickOnConfirmation,
  okClickOnConfirmation
}) => {
  return (
    <CommonModal
      open={showConfirmationPopup}
      body={showConfirmationMsg}
      buttons={
        <>
          <Button onClick={() => okClickOnConfirmation()} variant="outlined">
            {t("common.ok")}
          </Button>
          <Button
            onClick={() => cancelClickOnConfirmation()}
            variant="contained"
          >
            {t("common.cancel")}
          </Button>
        </>
      }
    />
  );
};

export default ConfirmationModal;
